export default __webpack_public_path__ + "static/media/03.e80fb34e.jpg";